import React, { useEffect, useState } from 'react'
import { NavLink, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const PasswordReset = () => {

    const [password, setPassword] = useState()
    const [massage, setMassage] = useState(false)

    const { id, token } = useParams()

    const userValid = async () => {
        const res = await fetch(`/forgetPass/${id}/${token}`, {
            method: "GET",
            headers: {
                "Content-Type": 'application/json'
            },
        });

        const data = await res.json();

        if (data.status === 201) {
            console.log("valid user")
        } else {
            console.log("Invalid User")

        }
    }



    const createPassword = async () => {
        const res = await fetch(`/${id}/${token}`, {
            method: "POST",
            headers: {
                "Content-Type": 'application/json'
            },
            body: JSON.stringify({ password })
        });

        const data = await res.json();
        if (data.status === 201) {
            setMassage(true)
            setPassword('')
        } else {
            toast.error("! Token Expired generate new link")
        }
    }

    useEffect(() => {
        (async () => await userValid())()
    },[])

    return (
        <div className='conatiner-fluid signup_container'>
            <div className='row'>

                <div className='col-md-6 col-sm-10 signup_form_left' >
                    <div style={{ fontSize: '1.2rem', color: 'darkgreen' }}>Create new password</div>
                    <div className="mb-3 mt-3">
                        <label for="uname" className="form-label">password</label>
                        {
                            massage ? <p style={{ color: 'green', fontWeight: 'bold' }}>password successfully updated</p> : ''
                        }
                        <input type="password"
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                            className="form-control" id="uname" placeholder="create password" name="uname" required />

                    </div>


                    <div className='mb-3 mt-2'>
                        <NavLink to='/login/forgetPass/reset'>
                            <button
                                onClick={createPassword}
                                style={{ width: '220px' }} type="submit" className="btn btn-primary">set new password</button>
                        </NavLink>
                        <ToastContainer />
                    </div>
                </div>

                <div className='col-md-6 col-sm-10 signup_form_right'>
                    <img src='https://img.freepik.com/free-vector/forgot-password-concept-illustration_114360-1095.jpg?w=740&t=st=1696342731~exp=1696343331~hmac=e3b9092d729218565a6457c5ccf0f74d98d68c35fee1f1760c5d1feb4190d281' className='img-fluid' alt='' />
                </div>

            </div>
        </div>
    )
}

export default PasswordReset;